import { render, staticRenderFns } from "./sluser.vue?vue&type=template&id=39bc988c&"
import script from "./sluser.vue?vue&type=script&lang=js&"
export * from "./sluser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports